<template>
  <a-drawer width="70%" :label-col="4" :wrapper-col="14" :visible="open"  @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>商城订单详情</b>
    </a-divider>
    <!--订单状态步骤条-->
    <a-steps v-if="this.record.id" :current="this.record.operateLogList.length-1" size="small">
      <a-step v-for="(item, index) in this.record.operateLogList" :key="index" >
        <template slot="title">
          <div style=" font-size: 18px">{{item.statusEvent}}</div>
          <div><custom-dict-tag :options="customDict.OrderSellMallStatusEnum" :value="item.orderStatus"/></div>
          <div v-if="item.remark">{{item.remark}}</div>
          <div>{{item.createTime}}</div>
        </template>
      </a-step>
    </a-steps>

    <div class="order-info">
      <table>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" :title="$t('订单信息')"
                    :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                    :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">{{$t('订单编号')}}：</td>
                  <td class="data">
                    {{ this.record.id}}
                  </td>
                  <td class="first">{{$t('订单状态')}}：</td>
                  <td class="data">
                    <custom-dict-tag :options="customDict.OrderSellMallStatusEnum" :value="record.orderStatus"/>
                  </td>
                  <td class="first">{{$t('下单时间')}}：</td>
                  <td class="data">
                    {{ this.record.createTime}}
                  </td>
                </tr>
                <tr>
                  <td class="first">父订单号：</td>
                  <td class="data">
                    {{ this.record.parentId}}
                  </td>
                  <td class="first">{{$t('订单来源')}}：</td>
                  <td class="data">
                    <custom-dict-tag :options="customDict.SourceEnum" :value="record.source"/>
                  </td>
                  <td class="first">催发货：</td>
                  <td class="data">
                    <custom-dict-tag :options="customDict.TFEnum" :color="true" :color-array="['red','green']" :value="record.isRemind"/>
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('商家')}}：</td>
                  <td class="data">
                    {{ this.record.merchantName}}
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('买家ID')}}：</td>
                  <td class="data">
                    {{ this.record.buyerId}}
                  </td>
                  <td class="first">{{$t('买家名称')}}：</td>
                  <td class="data">
                    {{ this.record.buyerName}}
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('支付时间')}}：</td>
                  <td class="data">
                    {{ this.record.payTime}}
                  </td>
                  <td class="first">{{$t('支付方式')}}：</td>
                  <td class="data">
                    <custom-dict-tag :options="customDict.OrderPayTypeEnum" :value="record.payType"/>
                  </td>
                  <td class="first">{{$t('三方订单号')}}：</td>
                  <td class="data">
                    {{ this.record.outTradeNo}}
                  </td>
                </tr>

                <tr>
                  <td class="first">{{$t('订单金额')}}：</td>
                  <td class="data">
                    {{ this.record.orderAmount}}
                  </td>
                  <td class="first">{{$t('商品金额')}}：</td>
                  <td class="data">
                    {{ this.record.goodsAmount}}
                  </td>
                  <td class="first">{{$t('实付金额')}}：</td>
                  <td class="data">
                    {{ this.record.payAmount}}
                  </td>
                </tr>
                <tr>
                  <td class="first">含税金额：</td>
                  <td class="data">
                    {{ this.record.payAmount}}
                  </td>
                  <td class="first">{{$t('商品数量')}}：</td>
                  <td class="data">
                    {{ this.record.goodsCount}}
                  </td>
                  <td class="first">获得积分：</td>
                  <td class="data">
                    {{ this.record.scoreObtain}}
                  </td>
                </tr>
                <tr>
                  <td class="first">券优惠金额（平台）：</td>
                  <td class="data">
                    {{ this.record.platCouponReduceAmount}}
                  </td>
                  <td class="first">券优惠金额（商家）：</td>
                  <td class="data">
                    {{ this.record.merchantCouponReduceAmount}}
                  </td>
                  <td class="first">会员折扣优惠：</td>
                  <td class="data">
                    {{ this.record.memberReduceAmount}}
                  </td>
                </tr>
                <tr>
                  <td class="first">活动优惠金额：</td>
                  <td class="data">
                    {{ this.record.activityReduceAmount}}
                  </td>
                  <td class="first">数量折扣优惠：</td>
                  <td class="data">
                    {{ this.record.goodsCountReduceAmount}}
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('运费金额')}}：</td>
                  <td class="data">
                    {{ this.record.shippingAmount}}
                  </td>
                  <td class="first">{{$t('运费实付')}}：</td>
                  <td class="data">
                    {{ this.record.shippingPayAmount}}
                  </td>
                  <td class="first">运费优惠：</td>
                  <td class="data">
                    {{ this.record.shippingReduceAmount}}
                  </td>
                </tr>
                <tr>
                  <td class="first">退款余额：</td>
                  <td class="data">
                    {{ this.record.lastRefundAmount}}
                  </td>
                  <td class="first">退款中金额：</td>
                  <td class="data">
                    {{ this.record.refundApplyAmount}}
                  </td>
                  <td class="first">已退款金额：</td>
                  <td class="data">
                    {{ this.record.refundedAmount}}
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('用户备注')}}：</td>
                  <td  colspan="7">
                    {{ this.record.userMessage}}
                  </td>
                </tr>
                <tr v-if="record.orderDeliveryDetail">
                  <td class="first">{{$t('物流单号')}}：</td>
                  <td class="data">
                    {{ this.record.orderDeliveryDetail.logisticsNo}}
                  </td>
                  <td class="first">{{$t('发货时间')}}：</td>
                  <td class="data">
                    {{ this.record.orderDeliveryDetail.createTime}}
                  </td>
                  <td class="data">
                    <a-button type="primary" v-if="record.orderStatus>=2030 && record.orderStatus<=2050"  @click="$refs.logisticDetail.handleDetail(record.id)">
                      {{$t('物流详情')}}
                    </a-button>
                  </td>
                </tr>
                <tr v-if="record.receiveTime">
                  <td class="first">预计收货时间：</td>
                  <td class="data">
                    {{ this.record.receiveTime}}
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>
        <tr v-if="record.deliveryList && record.deliveryList.length>0">
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" title="物流信息"
                     :headStyle="{'background-color':'#f3f3f3','height': '10px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <a-table  :bordered="false" :pagination="false" :columns="deliveryColumns" rowKey="skuId" :data-source="record.deliveryList">
                <template slot="logisticDetail" slot-scope="text, deliveryRecord">
                  <div>
                    <a-button type="primary"  @click="openLogistics(deliveryRecord.logisticsNo)">
                      {{$t('物流详情')}}
                    </a-button>
                  </div>
                </template>
              </a-table>
            </a-card>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" :title="$t('商品信息')"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <a-table  :bordered="false" :pagination="false" :columns="goodsColumns" rowKey="goodsId" :data-source="record.orderItemList">
                <template slot="picture" slot-scope="text, record">
                  <div>
                    <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
                  </div>
                </template>
              </a-table>
            </a-card>
          </td>
        </tr>

        <tr v-if="record.orderActivityDetail!=null">
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" :title="$t('活动信息')"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <table class="info-table">
                <tr>
                  <td class="first">{{$t('活动记录.活动编号')}}：</td>
                  <td class="data">
                    {{ this.record.orderActivityDetail.id}}
                  </td>
                  <td class="first">{{$t('活动记录.活动名称')}}：</td>
                  <td class="data">
                    {{ this.record.orderActivityDetail.activityName}}
                  </td>
                  <td class="first">{{$t('活动记录.活动封面图')}}：</td>
                  <td class="data">
                    <div>
                      <img v-if="record.orderActivityDetail.coverPic" :src="record.orderActivityDetail.coverPic"  style="width:60px;height:62px;" @click="handleRecordPreview(record.orderActivityDetail.coverPic)" alt="none"/>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('活动记录.开始时间')}}：</td>
                  <td class="data">
                    {{ this.record.orderActivityDetail.startTime}}
                  </td>
                  <td class="first">{{$t('活动记录.结束时间')}}：</td>
                  <td class="data">
                    {{ this.record.orderActivityDetail.endTime}}
                  </td>
                </tr>
              </table>
            </a-card>
          </td>
        </tr>

        <tr>
          <td style="vertical-align: top;background-color:#fbfbfb;">
            <a-card  :bordered="false" :title="$t('收货地址信息')"
                     :headStyle="{'background-color':'#f3f3f3','height': '29px','border-bottom': '1px solid #DDD','margin-bottom':'0'}"
                     :bodyStyle="{'background-color':'#fbfbfb'}">
              <a slot="extra">
                <a-button type="link" v-if="record.orderStatus>=2010 && record.orderStatus<2030" @click="$refs.userAddress.handleDetail(record.id ,record.buyerId);">
                  修改地址
                </a-button>
                <a-button type="link" @click="$refs.changeLogModal.handleDetail(record.id,1);">
                  变更记录
                </a-button>
              </a>
              <table class="info-table">
                <tr>
                  <td class="first">{{$t('收货人姓名')}}：</td>
                  <td class="data">
                    {{ this.record.addressDetail.realName}}
                  </td>
                  <td class="first">{{$t('性别')}}：</td>
                  <td class="data">
                    <custom-dict-tag :options="customDict.SexEnum" :value="record.addressDetail.sex"/>
                  </td>
                  <td class="first">{{$t('手机号')}}：</td>
                  <td class="data">
                    {{this.record.addressDetail.mobile}}
                  </td>
                </tr>
                <tr>
                  <td class="first">{{$t('详细地址')}}：</td>
                  <td  colspan="5">
                    {{ this.record.addressDetail.areap + this.record.addressDetail.areac + this.record.addressDetail.areax+this.record.addressDetail.detailedAddress}}
                  </td>
                </tr>

              </table>
            </a-card>
          </td>
        </tr>
      </table>
      <logistic-detail ref="logisticDetail"/>
      <delivery-form ref="deliveryForm" @ok="handleDetail(record.id)"/>
      <change-log ref="changeLogModal" />
      <user-address ref="userAddress" @ok="handleDetail(record.id)"/>
      <RefundAmountForm ref="refundAmountForm" :order="record"  @ok="handleDetail(record.id)"/>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
    </div>
    <div class="bottom-control">
      <a-space>
        <a-button type="primary"  v-hasPermi="['order:sell:delivery']"  v-if="this.record.orderStatus===2020 && this.record.isSplit"  @click="$refs.deliveryForm.handleDelivery(record.id)">
          {{$t('发货')}}
        </a-button>
        <a-button type="primary"  v-hasPermi="['order:sell:pay']"  v-if="(this.record.orderStatus === 2010|| this.record.orderStatus === 2060) && this.record.payType===5" :loading="submitLoading" @click="handlePay">
          确认支付
        </a-button>
        <a-button type="danger"  v-hasPermi="['order:refund:apply']"  v-if="this.record.isShowRefund && this.record.isSplit"  @click="handleRefund(record.id)">
          {{$t('退款')}}
        </a-button>
        <a-button type="danger"  v-hasPermi="['order:refund:apply']"  v-if="this.record.isShowRefund && this.record.isSplit"  @click="$refs.refundAmountForm.handleDetail()">
          部分退款
        </a-button>
        <a-button type="dashed" @click="cancel">
          {{$t('关闭')}}
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>
import {getSell, sellPay, updateRemark} from '@/api/order/sell'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import LogisticDetail from "./LogisticDetail";
import DeliveryForm from "./DeliveryForm";
import ChangeLog from "./ChangeLog.vue";
import UserAddress from "./UserAddress.vue";
import {refundApply} from "@/api/order/refund";
import RefundAmountForm from "./RefundAmountForm.vue";
import EditableCell from "@/components/EditableCell";


export default {
  name: 'detailForm',
  props: {
  },
  components: {
    CustomDictTag,
    RefundAmountForm,
    LogisticDetail,
    ChangeLog,
    EditableCell,
    UserAddress,
    DeliveryForm,
  },
  data () {
    return {
      record: {
        id:null,
        addressDetail: {},
        orderRaiseResult: {},
        orderActivityDetail: {},
      } ,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      // 表单参数
      form: {
        id: null,
        outTradeNo: null,
        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      goodsColumns: [
        {
          title: this.$t('商品名称'),
          dataIndex: 'goodsName',
          align: 'center',
        },
        {
          title: this.$t('商品主图'),
          dataIndex: 'picture',
          scopedSlots: {customRender: 'picture'},
          align: 'center'
        },
        {
          title: this.$t('规格名称'),
          dataIndex: 'skuName',
          align: 'center'
        },
        {
          title: this.$t('商品数量'),
          dataIndex: 'goodsCount',
          align: 'center'
        },
        {
          title: this.$t('商品价格'),
          dataIndex: 'price',
          align: 'center'
        },
        {
          title: this.$t('实付单价'),
          dataIndex: 'payPrice',
          align: 'center'
        },
      ],
      deliveryColumns: [
        {
          title: '物流单号',
          dataIndex: 'logisticsNo',
          align: 'center',
        },
        {
          title: '物流公司',
          dataIndex: 'logisticsName',
          align: 'center',
        },
        {
          title: '发货时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title:'物流详情',
          dataIndex: 'logisticDetail',
          scopedSlots: {customRender: 'logisticDetail'},
          align: 'center'
        },
      ],

      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        outTradeNo: null,
        remark: null,
      }
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    openLogistics(no) {
      const url = new URL('https://www.kuaidi100.com/chaxun');
      url.searchParams.set('nu', no);
      window.open(url.toString(), "_blank");
    },
    /** 修改按钮操作 */
    handleDetail(id) {
      this.reset()
      this.formType = 2
      getSell({"id":id}).then(response => {
        this.record = response.data
        this.open = true
      })
    },
    handlePay() {
      var id = this.record.id
      sellPay({"id":id}).then(response => {
        this.$message.success('确认支付成功', 3)
        this.handleDetail(id)
      }).finally(() => {
        this.submitLoading = false
      })
    },
    handleRefund(id) {
      let that = this
      let form = {"orderId":id ,"remark":"后台手动退款"}
      this.$confirm({
        title: '是否确认退款',
        content: '此操作将生成退款单,并退款',
        onOk () {
          that.record.orderStatus =2070
          refundApply(form).then(resp => {
            if (resp.code==='20001') {
              that.$message.success('退款成功', 3);
              that.handleDetail(id)
              that.record.orderStatus =2070
              this.open = false
              this.$emit('ok')
            }
          });
        },
        onCancel () {}
      })
    },
    editRemark(remark, id) {
      let data= {"id":id,"userMessage":remark}
      updateRemark(data).then(response => {
        this.$message.success('备注成功', 3)
        this.record.userMessage = remark
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            payAdvert(this.form).then(response => {
              this.$message.success(
                '支付成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.title {
  color: rgba(0, 0, 0, .85);
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}

.message-text {
  font-family: MicrosoftYaHei;
  font-size: 1rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3rem;
  letter-spacing: 0rem;
  color: #333333;
  width: 50%;
}

.fontblack {
  color: #999999
}

.img2 {
  width: .81rem;
  height: .8rem;
  float: right;
}


.orderTitle {
  font-size: 1rem;
  color: #333333;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  height: 2.5rem;
}

.orderDetail {
  font-size: 0.8rem;
  color: #666666;
  text-align: left;
}

.border-ceter {
  width: 92%;
  padding-left: 15px;
  padding-right: 15px;
}

.pay-button {
  width: 88%;
  height: 2.6rem;
  position: relative;
  background-color: red;
  color: white;

  margin-left: 6%;
}

ul li {
  list-style: none;
  font-size: 1rem;
}

ul {
  padding-left: 1.5rem
}

.track-rcol {
}

.track-list {
  position: relative;
}

.track-list li {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 1rem;
  border-left: 1px solid #d9d9d9;
  color: #999;
}

.track-list li.first {
  color: red;
  padding-top: 0;
  width: 100%;
  text-align: left;
  border-left: 1px solid #d9d9d9;
}

.track-list li .node-icon {
  position: absolute;
  left: -5.5px;
  border-radius: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  top: 4px;
  background-color: #999999;
}

.track-list li.first .node-icon {
  background-position: 0-72px;
  background-color: red;
  width: 1rem;
  z-index: 2;
  height: 1rem;
  position: absolute;
  left: -9px;
  top: 0;
  border-radius: 0.5rem;
}

.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
  background-color: white;
  color: #999;
  width: 100%;
  text-align: left;
}

.track-list li .txt {
  position: relative;
  display: inline-block;
  vertical-align: top;
  color: #999;
}

.track-list li.first .time {
  text-align: left;
  width: 94%;
  color: red;
}

.track-list li.first .txt {
  color: red;
  text-align: left;
  width: 94%;
}

.track-list li.finall {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 18px;
  border-color: white;
  border-left: 1px solid #ffffff;
  color: #999;
}

.track-list li.finall .div-spilander {
  width: 1px;
  position: absolute;
  position: absolute;
  left: -1.5px;
  height: 0.5rem;
  background-color: #d9d9d9;
}
.info-table .first {
  width: 105px;
  vertical-align: middle;     /* 垂直居中 */
  white-space: normal;        /* 允许换行 */
  word-break: break-all;      /* 长单词换行 */
}
.order-info {
  border: 1px solid #e8e8e8;
  margin-top: 40px;

  .info-table {
    tr {
      height: 50px;
    }
    td {
      display: table-cell;
      vertical-align: top;
      font-size: 16px;
    }
    .data {
      width: 300px;
    }
  }
}

.detailPanel {
  dd, dt {
    display: inline-block;
    vertical-align: center;
  }

  dt img {
    margin: 0 20px 5px 0px;
  }

  dd {
    h3 {
      font-weight: bold;
    }
  }

  .trade-detail-prompt {
    margin-left: 35px;

    li {
      font-size: 13px !important;

      .dotted-node {
        padding: 0 5px;
      }
    }
  }
}

.order-money {
  .om-c1 {
    font-size: 14px;
    color: #666
  }

  .om-c2 {
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .om-c3 {
    font-size: 16px;
    color: #DE3636;
    font-weight: bold;
  }

  td {
    text-align: right;
  }

  float: right;
  margin: 20px 40px 20px 0;
}
</style>
